import { render, staticRenderFns } from "./Header-top.vue?vue&type=template&id=b31ff1a6&scoped=true&"
import script from "./Header-top.vue?vue&type=script&lang=js&"
export * from "./Header-top.vue?vue&type=script&lang=js&"
import style0 from "./Header-top.vue?vue&type=style&index=0&id=b31ff1a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31ff1a6",
  null
  
)

export default component.exports